<template>
  <div class="container">
    <img src="@/assets/images/productPage1.png" />
    <img src="@/assets/images/productPage2.png" />
    <img src="@/assets/images/productPage3.png" />
    <img src="@/assets/images/productPage4.png" />
  </div>
</template>

<script>
export default {
  name: 'Product',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container {
  img {
    display: block;
    width: 100%;
  }
}
</style>